<div class="row">
	<mat-grid-list> <mat-grid-tile>
	<mat-card> <mat-card-title>Registration</mat-card-title>
	<mat-card-content><!--
						<p class="grey-blue-text text-darken-4">
							<i class="material-icons  left grey-blue-text text-darken-4">view_comfy</i>
						</p>
						<h4 class="grey-blue-text text-darken-4">Registration</h4>-->
	<form (ngSubmit)="onSubmit()">
		<div class="row">
			<div class="input-field col s12">
				<mat-form-field> <mat-label>First</mat-label> <input
					id="first" type="text" [(ngModel)]="first"
					[ngModelOptions]="{standalone: true}" matInput> </mat-form-field>

			</div>
		</div>
		<div class="row">
			<div class="input-field col s12">
				<mat-form-field> <mat-label>Last</mat-label> <input
					type="text" [(ngModel)]="last" id="last"
					[ngModelOptions]="{standalone: true}" matInput> </mat-form-field>


			</div>
		</div>

		<div class="row">
			<div class="input-field col s12">
				<mat-form-field> <mat-label>Middle</mat-label> <input
					type="text" [(ngModel)]="middle" id="middle"
					[ngModelOptions]="{standalone: true}" matInput> </mat-form-field>



			</div>
		</div>
		<div class="row">
			<div class="input-field col s12">

				<mat-form-field> <mat-label>Account</mat-label> <input
					type="text" [(ngModel)]="selfsuperscription"
					id="selfsuperscription" [ngModelOptions]="{standalone: true}"
					matInput> </mat-form-field>

			</div>
		</div>
		<div class="drow">
			<mat-form-field>
			<mat-label>Password</mat-label> <input [(ngModel)]="password"
				id="password" [type]="hide() ? 'password' : 'text'"
				[ngModelOptions]="{standalone: true}" matInput>
			<button mat-icon-button matSuffix class="example-right-align"
				(click)="lookEvent($event)" [attr.aria-label]="'Hide password'"
				[attr.aria-pressed]="hide()">
				<mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
			</button>
			</mat-form-field>
			<mat-form-field> <mat-label>Conformation</mat-label> <input [(ngModel)]="cpassword" id="cpassword"
				[type]="hide() ? 'password' : 'text'"
				[ngModelOptions]="{standalone: true}" matInput>
			<button mat-icon-button matSuffix class="example-right-align"
				(click)="lookEvent($event)" [attr.aria-label]="'Hide password'"
				[attr.aria-pressed]="hide()">
				<mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
			</button>
			</mat-form-field>

		</div>
		<div class="row">
			<div class="input-field col s12">
				<mat-form-field> <mat-label>Phone</mat-label> <input
					type="text" placeholder="+" [(ngModel)]="phone" id="phone"
					[ngModelOptions]="{standalone: true}" matInput> </mat-form-field>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12">

				<mat-form-field> <mat-label>E-mail</mat-label> <input
					type="text" [(ngModel)]="post" id="post"
					[ngModelOptions]="{standalone: true}" matInput> </mat-form-field>

			</div>
		</div>
		<button class="btn waves-effect waves-light indigo lighten-2"
			type="submit" name="action" mat-raised-button>.`-</button>
	</form>
	</mat-card-content> </mat-card> </mat-grid-tile> </mat-grid-list>
</div>
